import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddEditProduct from "../components/AddEditProduct";

const AddProductPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Add Product' />

                <AddEditProduct />

            </MasterLayout>
        </>
    );
};

export default AddProductPage;
